import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultarEnComponent } from './consultar-en.component';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { AuthAdminGuard } from 'app/auth/auth-admin.guard';
import {MatSelectModule} from '@angular/material/select';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import { FlexLayoutModule } from "@angular/flex-layout";
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import { StylePaginatorDirective } from './style-paginator.directive';
import {MatPaginatorModule} from '@angular/material/paginator';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

const rutas: Routes = [
    // trust index
    {
        path     : 'consultar/consultasencuesta',
        component: ConsultarEnComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    }
];

@NgModule({
  declarations: [ConsultarEnComponent,StylePaginatorDirective],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    MatSelectModule,
    MatTableModule,
    MatInputModule,
    FlexLayoutModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatIconModule,
    MatPaginatorModule
  ]
})
export class ConsultarEnModule { }
